import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PoliciesURL } from "../../APIs/APIUrls";
import "./PrivacyPolicy.css";

export default function PrivacyPolicy() {
  const [policyHtml, setPolicyHtml] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    async function fetchPolicies() {
      try {
        const response = await fetch(PoliciesURL + "GetAllPoliciesfor_web", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({}),
        });
        const text = await response.text();
        let data;
        try {
          data = JSON.parse(text);
        } catch (e) {
          data = text;
        }

        let items = [];
        if (Array.isArray(data)) items = data;
        else if (data && Array.isArray(data.Data)) items = data.Data;
        else if (data && Array.isArray(data.Result)) items = data.Result;
        else if (data && Array.isArray(data.response)) items = data.response;
        else if (data && Array.isArray(data.List)) items = data.List;

        if (items.length === 0 && data && typeof data === "object") {
          for (const k in data) {
            if (Array.isArray(data[k])) {
              items = data[k];
              break;
            }
          }
        }

        let policy = null;
        if (items && items.length) {
          policy = items.find(
            (p) =>
              Number(p.TypeId) === 200 ||
              Number(p.TypeID) === 200 ||
              String(p.Value) === "200" ||
              (p.PolicyType && p.PolicyType.toLowerCase().includes("privacy"))
          );
        } else if (data && data.PolicyContent && (Number(data.TypeId) === 200 || String(data.Value) === "200")) {
          policy = data;
        }

        if (mounted) {
          if (policy && (policy.PolicyContent || policy.Value)) {
            setPolicyHtml(policy.PolicyContent || policy.Value || "");
          } else if (items.length) {
            setPolicyHtml(items[0].PolicyContent || items[0].Value || "");
          } else {
            setPolicyHtml("");
          }
        }
      } catch (err) {
        console.error(err);
        if (mounted) setError(err);
      } finally {
        if (mounted) setLoading(false);
      }
    }

    fetchPolicies();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <section className="flat-section flat-wrapper-privacy">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 wrapper-privacy">
            <div className="box-item mb-30">
              <h4 className="mb-30">Privacy Policy</h4>
              {loading ? (
                <p>Loading privacy policy...</p>
              ) : error ? (
                <p>Unable to load privacy policy.</p>
              ) : policyHtml ? (
                <div dangerouslySetInnerHTML={{ __html: policyHtml }} />
              ) : null}
            </div>
            {/* <div className="box-item mb-30">
              <h6 className="mb-20">Who we are</h6>
              <p className="mb-20">
                In this policy, “we” “us” and “our” are Dream home Pty Limited
                and our related businesses.
              </p>
              <div className="mb-20">
                <p className="mb-10">
                  We run these websites across desktop, mobile, tablet and apps:
                </p>
                <ul className="list-default mb-10">
                  <li>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  </li>
                  <li>Integer nec mauris at purus condimentum commodo.</li>
                  <li>Vivamus eu dolor vitae ligula dignissim eleifend.</li>
                  <li>
                    Pellentesque ac odio ullamcorper, euismod elit a, lacinia
                    diam.
                  </li>
                  <li>Duis nec nisi at ligula cursus sollicitudin.</li>
                  <li>
                    Morbi ultrices odio quis neque vulputate, sit amet tristique
                    nisi ultricies.
                  </li>
                  <li>Ut pellentesque diam eget neque accumsan</li>
                </ul>
                <p>Ut pellentesque diam eget neque accumsan</p>
              </div>
              <p>
                In the Credit Reporting Policy, “REA” or “we”, “our” and “us”
                refer only to Deamhome Pty Limited. Where we refer to the data
                practices of a specific business, "we", "our" or "us" refers to
                the operating entity of that business.
              </p>
            </div>
            <div className="box-item mb-30">
              <h6 className="mb-20">How we respect information privacy</h6>
              <p className="mb-20">
                We understand the importance of protecting your personal
                information.
              </p>
              <p>
                Whenever we collect and handle personal info, we’re bound by the
                Privacy Act. That includes the Australian Privacy Principles
                (“APPs”).
              </p>
            </div>
            <div className="box-item">
              <h6 className="mb-20">
                Information we collect, how we use it and how we disclose it
              </h6>
              <p className="mb-20">
                The kinds of things you do on our websites might mean we need to
                collect your personal information. If you want us to send you
                emails, for example, we’ll need to collect your email address.
                So, a lot of the time, you’ll know what info we’re collecting,
                and when. After all, you’ll be giving us the information
                yourself.
              </p>
              <p className="mb-20">
                We might also collect non-personal information, like a list of
                the pages you look at on our websites. We do this so that we can
                give you the most helpful, personal experience of our services.
                For example, we use it to suggest properties like the ones you
                look at most often. We often use cookies or other technology to
                collect this kind of info. So, you might not realise every time
                it’s happening.
              </p>
              <div className="mb-20">
                <p className="mb-10">
                  By using our sites, you agree to only ever give us:
                </p>
                <ul className="list-default mb-10">
                  <li>your own personal information, or</li>
                  <li>
                    personal info someone's agreed for you to share with us,
                    like a referee in a rental application.
                  </li>
                </ul>
              </div>
              <p className="mb-20">
                We’ll only ever use or share your information for the purpose
                you gave it to us for, or something closely related to that. For
                example, if your sign up to a newsletter for first-home buyers,
                we might also show you articles with home-buying tips when you
                come to our websites.
              </p>
              <p>
                You can always control the information we collect about you.
              </p>
            </div> */}
          </div>
          {/* <div className="col-lg-4">
            <div className="sidebar-privacy">
              <div className="cate-privacy-box">
                <h5 className="mb-20">Categories</h5>
                <ul className="list-cate-privacy">
                  <li>
                    <a href="#">
                      <span>Terms Of Use</span>
                      <svg
                        className="icon"
                        width={18}
                        height={18}
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.9375 6.1875L16.75 9M16.75 9L13.9375 11.8125M16.75 9H3.25"
                          stroke="black"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>Limitations</span>
                      <svg
                        className="icon"
                        width={18}
                        height={18}
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.9375 6.1875L16.75 9M16.75 9L13.9375 11.8125M16.75 9H3.25"
                          stroke="black"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>Revisions and errata</span>
                      <svg
                        className="icon"
                        width={18}
                        height={18}
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.9375 6.1875L16.75 9M16.75 9L13.9375 11.8125M16.75 9H3.25"
                          stroke="black"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>Site terms of use modifications</span>
                      <svg
                        className="icon"
                        width={18}
                        height={18}
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.9375 6.1875L16.75 9M16.75 9L13.9375 11.8125M16.75 9H3.25"
                          stroke="black"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>Risks</span>
                      <svg
                        className="icon"
                        width={18}
                        height={18}
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.9375 6.1875L16.75 9M16.75 9L13.9375 11.8125M16.75 9H3.25"
                          stroke="black"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="contact-box">
                <h5 className="mb-20">Contact us</h5>
                <p className="desc">
                  We're here to support you! Check out our help centre for
                  further assistance.
                </p>
                <Link to={`/contact`} className="tf-btn primary">
                  <svg
                    width={21}
                    height={20}
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.6875 8.125C7.6875 8.20788 7.65458 8.28737 7.59597 8.34597C7.53737 8.40458 7.45788 8.4375 7.375 8.4375C7.29212 8.4375 7.21263 8.40458 7.15403 8.34597C7.09542 8.28737 7.0625 8.20788 7.0625 8.125C7.0625 8.04212 7.09542 7.96264 7.15403 7.90403C7.21263 7.84543 7.29212 7.8125 7.375 7.8125C7.45788 7.8125 7.53737 7.84543 7.59597 7.90403C7.65458 7.96264 7.6875 8.04212 7.6875 8.125ZM7.6875 8.125H7.375M10.8125 8.125C10.8125 8.20788 10.7796 8.28737 10.721 8.34597C10.6624 8.40458 10.5829 8.4375 10.5 8.4375C10.4171 8.4375 10.3376 8.40458 10.279 8.34597C10.2204 8.28737 10.1875 8.20788 10.1875 8.125C10.1875 8.04212 10.2204 7.96264 10.279 7.90403C10.3376 7.84543 10.4171 7.8125 10.5 7.8125C10.5829 7.8125 10.6624 7.84543 10.721 7.90403C10.7796 7.96264 10.8125 8.04212 10.8125 8.125ZM10.8125 8.125H10.5M13.9375 8.125C13.9375 8.20788 13.9046 8.28737 13.846 8.34597C13.7874 8.40458 13.7079 8.4375 13.625 8.4375C13.5421 8.4375 13.4626 8.40458 13.404 8.34597C13.3454 8.28737 13.3125 8.20788 13.3125 8.125C13.3125 8.04212 13.3454 7.96264 13.404 7.90403C13.4626 7.84543 13.5421 7.8125 13.625 7.8125C13.7079 7.8125 13.7874 7.84543 13.846 7.90403C13.9046 7.96264 13.9375 8.04212 13.9375 8.125ZM13.9375 8.125H13.625M2.375 10.6333C2.375 11.9667 3.31083 13.1283 4.63083 13.3225C5.53667 13.4558 6.45167 13.5583 7.375 13.63V17.5L10.8617 14.0142C11.0343 13.8422 11.2664 13.7432 11.51 13.7375C13.1363 13.6975 14.7588 13.5589 16.3683 13.3225C17.6892 13.1283 18.625 11.9675 18.625 10.6325V5.6175C18.625 4.2825 17.6892 3.12167 16.3692 2.9275C14.4258 2.64226 12.4642 2.49938 10.5 2.5C8.50667 2.5 6.54667 2.64584 4.63083 2.9275C3.31083 3.12167 2.375 4.28334 2.375 5.6175V10.6325V10.6333Z"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Visit Help Centre
                </Link>
                <h6 className="mb-20">You can also email</h6>
                <a href="#" className="text-mail">
                  Realestatecp@gmail.com
                </a>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}
